module.exports = __webpack_public_path__ + "img/refinery.97f2f047.png";